import React, { useEffect } from 'react';
import styled from 'styled-components';
import { SubContainer, SubTitle, SubValueChange, SubValueChangeMobile, SubWrapper, Title } from './MemberSetting';
import { DeviceType, ModalType } from '../../shared/enum/EnumRepository';
import { PaperBlurFitBtn } from '../../shared/component/headless/button/BtnBody';
import { useSetting } from '../../shared/hooks/useApi/useSetting';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { usePayment } from '../../shared/hooks/useApi/usePayment';
import { useAuth } from '../../shared/hooks/useApi/useAuth';
import HeadlessBtn from '../../shared/component/headless/button/HeadlessBtn';
import Arrow from '../../shared/component/Arrow';
import { openNewTab } from '../../shared/util/openNewTab';
import Storage from './Storage';
import SubscriptionBadge from '../../shared/component/SubscriptionBadge';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTempAlertStore } from '../../shared/store/portal/tempAlertStore';
import { useDeviceStore } from '../../shared/store/deviceStore';
import { getSettingsMessage } from '../../shared/constants/pageMessages';
import { getBtnName } from '../../shared/constants/btnNames';
import { getConfig } from '../../shared/env/envManager';

const Subscription: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isOwner } = useAuth();
  const { setting } = useSetting();
  const { setStandardModal } = useModalStore();
  const { currentPlan, getCurrentPlan, customerPortalUrl, getCustomerPortalUrl, isPortalFresh } = usePayment();
  const { setSubscriptionSuccessTempAlert } = useTempAlertStore();
  const { deviceType } = useDeviceStore();

  // URL 파라미터에서 subscribe=true가 있는지 확인하고 리로드 + 환영 메시지
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const subscribe = searchParams.get('subscribe');
    const currentPath = location.pathname;

    if (subscribe === 'true') {
      navigate(currentPath, { replace: true });
      setSubscriptionSuccessTempAlert();
    } else {
      navigate(currentPath, { replace: true });
    }
  }, [location.search, navigate]);

  useEffect(() => {
    const getCurrentPlanWithApi = async () => {
      if (isOwner) {
        await getCurrentPlan();
      }
    }
    getCurrentPlanWithApi();
  }, [isOwner]);

  if (!setting) return null;

  const handleManagePlan = async () => {
    if (isPortalFresh()) {
      openNewTab(customerPortalUrl!.url)
    } else {
      await getCustomerPortalUrl();
    }
  }

  const handleSubscription = async () => {
    setStandardModal({
      modalType: ModalType.SUBSCRIPTION,
      title: "Subscription",
      value: "",
      handleChange: () => { }
    });
  }

  const handleOpenPolarSh = () => {
    openNewTab(getConfig().paymentProcessorUrl);
  }

  const onSubscribe = currentPlan && currentPlan.name !== null && currentPlan.name !== "-" && currentPlan.status !== "CANCELED";

  return (
    <SubscriptionComp>
      <Title>Subscription
        {currentPlan && (
          <SubscriptionBadge
            status={currentPlan.status}
            currentPeriodEnd={currentPlan.currentPeriodEnd}
            cancelAtPeriodEnd={currentPlan.cancelAtPeriodEnd}
          />
        )}
      </Title>
      <SubContainer>
        <SubWrapper>
          <SubTitle>Plan
            <SubExplain>{getSettingsMessage('SUBSCRIPTION_MANAGED_BY')}
              <SubAnchor onClick={handleOpenPolarSh}>
                {getSettingsMessage('PAYMENT_PROCESSOR')}
                <ArrowWrapper>
                  <Arrow />
                </ArrowWrapper>
              </SubAnchor>
              <br />
              {onSubscribe ? getSettingsMessage('POLAR_OPEN_SUBSCRIPTION_PAGE') : getSettingsMessage('POLAR_OPEN_PAYMENT_PAGE')}
            </SubExplain>
          </SubTitle>
          <MoleculeDivBtnWrapper>
            {deviceType === DeviceType.MOBILE ? 
            <SubValueChangeMobile>{onSubscribe ? currentPlan.name : "-"}</SubValueChangeMobile> 
            : <SubValueChange>{onSubscribe ? currentPlan.name : "-"}</SubValueChange>
            }
            <HeadlessBtn
              value={onSubscribe ? getBtnName('MANAGE') : getBtnName('SUBSCRIBE')}
              handleClick={onSubscribe ? handleManagePlan : handleSubscription}
              StyledBtn={PaperBlurFitBtn}
            />
          </MoleculeDivBtnWrapper>
        </SubWrapper>
        <Storage
          storageData={currentPlan?.storage || null} />
      </SubContainer>
    </SubscriptionComp>
  );
}

const SubscriptionComp = styled.section`
  width: clamp(320px, 65%, 650px);
  height: fit-content;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`;


const MoleculeDivBtnWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5vw;
`;

const SubExplain = styled.div`
  width: fit-content;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
`
const SubAnchor = styled.div`
  position: relative;
  width: fit-content;
  min-width: 50px;
  max-width: 60px;
  height: 20px;

  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: clamp(4px, 0.4vw, 6px);
  text-decoration: underline;
  margin-left: 4px;

  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
  cursor: pointer;
`

const ArrowWrapper = styled.div`
  width: 12px;
  height: 12px;
`;


export default Subscription;